<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2021 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<scrm-chart-message-area *ngIf="!results || !results.length || results.length < 1"
                         labelKey="LBL_NO_DATA"></scrm-chart-message-area>
<ng-container *ngIf="view().length">
    <ngx-charts-bar-vertical *ngIf="results && results.length > 0"
                             class="vertical-bar-chart"
                             [animations]="false"
                             [results]="results"
                             [view]="view()"
                             [scheme]="scheme"
                             [gradient]="gradient"
                             [xAxis]="xAxis"
                             [yAxis]="yAxis"
                             [legend]="legend"
                             [legendTitle]="legendTitle"
                             [legendPosition]="'below'"
                             [showXAxisLabel]="showXAxisLabel"
                             [showYAxisLabel]="showYAxisLabel"
                             [xAxisLabel]="xAxisLabel"
                             [yAxisLabel]="yAxisLabel"
                             [noBarWhenZero]="noBarWhenZero"
                             [showDataLabel]="showDataLabel"
                             [rotateXAxisTicks]="rotateXAxisTicks"
                             [trimXAxisTicks]="trimXAxisTicks"
                             [maxYAxisTickLength]="maxYAxisTickLength"
                             [trimYAxisTicks]="trimYAxisTicks"
                             [maxXAxisTickLength]="maxXAxisTickLength"
                             [yAxisTickFormatting]="yAxisTickFormatting">
        <ng-template #tooltipTemplate let-model="model">
            <div>{{model.name}}</div>
            <div>{{ formatTooltipValue(model.value) }}</div>
        </ng-template>
    </ngx-charts-bar-vertical>
</ng-container>
<div *ngIf="!view().length && results && results.length > 0" [class.m-5]="true" class="chart-loading">
    <scrm-loading-spinner></scrm-loading-spinner>
</div>


